import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { MapMarker } from '@spi/shared';

export function useMapMarkers() {
  return useQuery({
    queryKey: ['map', 'markers'],
    queryFn: () => apiFetch<MapMarker[]>('/api/map/markers'),
  });
}
